import React from "react";
import { motion } from "framer-motion";

interface LoadingProps {
  src?: string;          // GIF 图片地址
  size?: number | string;// 图片大小 (宽度)，默认 100px
  height?: string;       // 容器高度，默认 100% (占满父容器)
  fullScreen?: boolean;  // 是否强制全屏覆盖
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({
  src = "https://nekoda.cn/usr/uploads/test-1735211807.gif", // 这里替换成你默认的 GIF 路径，比如 public/loading.gif
  size = 100,
  height = "100%",
  fullScreen = true,
  className = "",
}) => {
  // 容器的基础样式
  const containerStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    // 如果是 fullScreen 模式，则强制固定定位且占满屏幕，否则跟随父容器高度
    height: fullScreen ? "100vh" : height,
    position: fullScreen ? "fixed" : "relative",
    top: fullScreen ? 0 : "auto",
    left: fullScreen ? 0 : "auto",
    zIndex: fullScreen ? 9999 : 1, // 全屏模式层级要高
    backgroundColor: "transparent", // 全屏时给个背景色防止透底
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      style={containerStyle}
      className={className}
    >
      <img
        src={src}
        alt="Loading..."
        style={{
          width: size,
          height: "auto", // 保持比例
          objectFit: "contain",
        }}
      />
    </motion.div>
  );
};

export default Loading;